import NewText from "@components/NewText";
import { useState } from "react";
import { parseCSS } from "scripts/FunctionsBundle";
import styled, { css } from "styled-components";
import { login } from "utils/firebase";

// ################################ INTERFACES & PROPS ################################

type _Base = import("utils/class-types").Base;

type LoginScreenProps = {} & _Base;

// ################################ FUNCTION COMPONENT ################################

const _LoginForm = (props: LoginScreenProps) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  return (
    <section className={props.className}>
      <NewText
        _text={"Log In"}
        _type={"subtitle"}
        _variant={1}
        _align={"center"}
      />

      <div className={"form"}>
        <div className={"container"}>
          <NewText
            _text={"Email:"}
            _del_margin
            _type={"subtitle"}
            _variant={3}
            _this={{
              _converter: {
                _el: "label",
                _prop: {
                  htmlFor: "field-email",
                },
              },
            }}
            _styleText={{
              _fontSize: { _size: ["1.5rem"] },
            }}
          />

          <input
            id={"field-email"}
            type={"text"}
            placeholder={"me@admin.com..."}
            autoComplete={"off"}
            onChange={(e) => {
              setEmail(e.target.value);
            }}
            value={email}
          />
        </div>

        <div className={"container"}>
          <NewText
            _text={"Password:"}
            _del_margin
            _type={"subtitle"}
            _variant={3}
            _this={{
              _converter: {
                _el: "label",
                _prop: { htmlFor: "field-password" },
              },
            }}
          />

          <input
            id={"field-password"}
            type={"password"}
            autoComplete={"off"}
            onChange={(e) => {
              setPassword(e.target.value);
            }}
            value={password}
          />
        </div>

        <div className={"container"}>
          <NewText
            _text={"Log In"}
            _type={"button"}
            _this={{
              _converter: {
                _el: "button",
                _prop: {
                  onClick: () => {
                    login(email, password);
                  },
                },
              },
            }}
          />
        </div>
      </div>
    </section>
  );
};

// ################################ STYLES ################################
const LoginForm = styled(_LoginForm).attrs((props): LoginScreenProps => {
  return { ...props };
})`
  ${(props) => css`
    width: fit-content;
    margin: 0.75rem auto;

    .form {
      text-align: center;
      display: flex;
      flex-direction: column;
      justify-content: center;
      width: fit-content;

      .container {
        display: flex;
        flex-direction: row;
        text-align: start;
        justify-content: flex-start;
        align-items: baseline;
        min-width: 10rem;

        input,
        label,
        button {
          margin: 0.25rem 0.5rem;
        }

        input {
          font-size: 1rem;
          min-width: 15rem;
        }
      }
    }

    ${parseCSS(props._style)}
  `}
`;

// ################################ EXPORTS ################################

export default LoginForm;
